import { Component, ViewChild, ElementRef, OnInit, NgZone } from '@angular/core';
import { Router } from '@angular/router';

import { RegionService } from '../../services/region.service';
import { SessionService } from '../../services/session.service';
import { NetworkStatusService } from '../../services/network-status.service';
import { SharedConstants } from '../../services/shared/shared-constants';
import { TrackingService } from '../../services/tracking.service';

@Component({
  selector: 'slide3-page',
  templateUrl: 'slide3.html',
})
export class Slide3Page implements OnInit {
  height: number;
  width: number;
  radius: number;

  @ViewChild('kioskcontent') elementView: ElementRef;
  viewHeight: any;
  onlineStatus: boolean;
  constructor(
    private router: Router,
    public regionService: RegionService,
    public sessionService: SessionService,
    public networkService: NetworkStatusService,
    public zone: NgZone,
    private trackingService: TrackingService
  ) {
    this.networkService.online$.subscribe((res) => {
      this.onlineStatus = res;
    });
    window.addEventListener('orientationchange', () => {
      this.changeSliderSize();
    });
  }

  ngOnInit() {
    this.changeSliderSize();
  }

  private changeSliderSize() {
    if (this.isMobileDevice()) {
      this.height = screen.height / 2.2;
      this.width = this.height;
      this.radius = this.height / 3.2;
    } else {
      this.height = screen.height / 2;
      this.width = this.height;
      this.radius = this.height / 3.2;
    }
  }
  onResize(event) {
    if (!this.isMobileDevice() && event.target.innerWidth < 1024) {
      this.height = event.target.innerWidth / 2;
      this.width = this.height;
      this.radius = this.height / 3.2;
      this.zone.run(() => {
        console.log('force update');
      });
    }
  }

  prev(): void {
    this.onlineStatus ? this.router.navigate(['age']) : this.networkService.presentToast(SharedConstants.networkErrorMessage);
    this.trackingService.resetTrackingValues();
  }

  next(): void {
    this.onlineStatus ? this.router.navigate(['devices']) : this.networkService.presentToast(SharedConstants.networkErrorMessage);
  }

  circleChangeEvent(value: number): void {
    this.sessionService.setCircleValues('Outdoor', value);
  }

  circleChangeEndEvent(value: number): void {
    this.sessionService.setCircleValues('Outdoor', value);
  }

  isMobileDevice() {
    return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
  }
}



// WEBPACK FOOTER //
// ./src/pages/slide3/slide3.ts